module.exports = "/_next/static/images/term-card-bg-f864da92cc24e781bdf7895cacdbefc5.svg";